export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_03.3c1e46a9.jpg";